<mat-card>
    <mat-card-header>
        <mat-card-title>
            {{ 'Comments' }}
            <mat-card-subtitle *ngIf="!isOwner">{{ '(visible to owners)' }}</mat-card-subtitle>
        </mat-card-title>
        <button mat-flat-button linkButton disableRipple
                [disabled]="loadingInitialData"
                (click)="addComment()">
            {{ 'Add Comment' }}
        </button>
    </mat-card-header>

    <mat-progress-bar mode="query" color="primary" [class.active]="!addCommentEnabled && formGroup.get('id').value">
    </mat-progress-bar>

    <mat-divider></mat-divider>

    <mat-card-content>
        <mat-list [loadingList]="!comments" [loadingLines]="2" [width]="'90%'">
            <app-empty-state *ngIf="!loadingInitialData && comments?.length === 0" align="left">
                <span emptyStateText>{{ 'No comments so far' }}</span>
            </app-empty-state>

            <ng-container *ngFor="let comment of comments">
                <mat-list-item [class.deleting]="!addCommentEnabled && formGroup.get('id').value === comment.id">
                    <span [innerHTML]="comment.message" matListItemLine></span>
                    <button [matMenuTriggerFor]="commentsMenu"
                            [disabled]="!addCommentEnabled && formGroup.get('id').value === comment.id"
                            mat-icon-button linkButton disableRipple matListItemMeta>
                        <mat-icon [svgIcon]="'v2:fi-br-menu-dots'"></mat-icon>
                    </button>
                    <mat-menu #commentsMenu="matMenu" xPosition="before" class="v2-panel" [overlapTrigger]="false">
                        <button (click)="editComment(comment.id)" mat-menu-item>{{ 'Edit Comment' }}</button>
                        <button (click)="deleteComment(comment.id)" mat-menu-item>{{ 'Delete Comment' }}</button>
                    </mat-menu>
                </mat-list-item>
                <mat-list-item [class.deleting]="!addCommentEnabled && formGroup.get('id').value === comment.id" authorLine>
                    <span [innerHTML]="comment.authorName + ' • ' + (comment.createdAt | legfiDate: 'MM/DD/YYYY h:mm a')"
                          matListItemLine>
                    </span>
                    <span [innerHTML]="!comment.updatedAt.isSame(comment.createdAt) ? '(edited)' : ''" matListItemLine></span>
                </mat-list-item>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-list>
    </mat-card-content>

    <section [formGroup]="formGroup" #editorContainer>
        <ng-container *ngIf="addCommentEnabled">
            <div class="form-group">
                <app-rich-text-editor type="compact"
                                      [useNewStyles]="true"
                                      [isLoading]="false"
                                      [formGroup]="formGroup"
                                      [controlName]="'comment'">
                    <mat-progress-bar mode="query" color="primary" [class.active]="!loadingInitialData && (isSaving || refreshingData)">
                    </mat-progress-bar>
                </app-rich-text-editor>
            </div>

            <mat-card-actions>
                <button mat-flat-button disableRipple color="accent" (click)="cancelEdit()">
                    {{ 'Cancel' }}
                </button>

                <flex-spacer></flex-spacer>

                <mat-slide-toggle formControlName="sendNotification" color="primary" disableRipple>
                    <span [innerHTML]="'Send notification' + (hasSelectedRecipients ? ' to' : '')"></span>
                    <button *ngIf="hasSelectedRecipients" linkButton preventClick
                            [innerHTML]="formGroup.get('recipients').value.length | i18nPlural: recipientsMapping"
                            (click)="showNotificationMemberSelector()">
                    </button>
                </mat-slide-toggle>

                <button-spacer></button-spacer>

                <button mat-flat-button disableRipple color="primary"
                        [disabled]="isSaving || !formGroup.get('comment').value"
                        (click)="publishComment(formGroup.get('id').value)">
                    {{ formGroup.get('id').value ? 'Update' : 'Publish' }}
                </button>
            </mat-card-actions>
        </ng-container>
    </section>
</mat-card>
